export default "__VITE_ASSET__CJ1uDknP__"